import { render, staticRenderFns } from "./NewsPreview.vue?vue&type=template&id=cb30d9fc"
import script from "./NewsPreview.vue?vue&type=script&lang=js"
export * from "./NewsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports